import React from 'react';
import { micahPortraitMusic, latestRelease } from '../data/products';
import './MusicPage.css';

const MusicPage: React.FC = () => {
  return (
    <div className="music-page">
      {/* Hero */}
      <section className="music-hero">
        <div className="music-hero__layout container">
          <div className="music-hero__copy">
            <h1 className="music-hero__title">Music</h1>
            <p className="music-hero__sub">
              Me, my guitar, and original jazz-r&b fusion songs from the heart.
            </p>
          </div>

          <div className="music-hero__image-col">
            <img
              src={micahPortraitMusic}
              alt="Micah Lynise, musician and artist"
              className="music-hero__image"
              width={375}
              height={500}
            />
          </div>
        </div>
      </section>

      {/* Upcoming Release */}
      <section className="music-release container">
        <p className="music-release__eyebrow">{latestRelease.eyebrow}</p>

        <div className="music-release__upcoming">
          <h2 className="music-release__title">{latestRelease.title}</h2>
          <p className="music-release__note">
            {latestRelease.note}
          </p>
          {latestRelease.stayTuned && (
            <p className="music-release__stay-tuned">
              {latestRelease.stayTuned}
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default MusicPage;
